import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getHomeInfo } from 'volto-ministerio-publico-federal/actions/homeInfo';
import {
  getHomeBlockData,
  type HomeInfoState,
} from 'volto-ministerio-publico-federal/helpers/HomeInfo/HomeInfo';
import type {
  DestaqueItem,
  DestaquesData,
} from 'volto-ministerio-publico-federal/components/View/CapaView/helpers';

interface UseHomeDestaquesResult {
  items: DestaqueItem[];
  /** Tokens dos temas curados para o bloco "Navegue por temas" (máx. 5). */
  temas: string[];
  loaded: boolean;
}

/**
 * Itens do bentô `mpfDestaques` da Home.
 *
 * Existe para a coluna lateral da notícia: por decisão de design, o card "Em
 * destaque" mostra exatamente o que os editores curaram no bentô da home, e a
 * lista é a mesma em todas as páginas de notícia — por isso a fonte é a Home,
 * e não uma busca relativa à notícia aberta.
 *
 * O `@home-info` é cacheado independentemente da publicação de notícias (ver a
 * docstring de `services/components/home/get.py`), então reusá-lo aqui não
 * acopla a invalidação daquele endpoint ao fluxo editorial de notícias.
 */
export function useHomeDestaques(): UseHomeDestaquesResult {
  const dispatch = useDispatch();
  const homeInfo = useSelector(
    (state: { homeInfo: HomeInfoState & { loaded?: boolean } }) =>
      state.homeInfo,
  );

  useEffect(() => {
    dispatch(getHomeInfo());
  }, [dispatch]);

  const destaques = getHomeBlockData(homeInfo?.items?.home, 'mpfDestaques') as
    | (DestaquesData & { temas?: string[] })
    | undefined;

  return {
    items: destaques?.items ?? [],
    temas: destaques?.temas ?? [],
    loaded: Boolean(homeInfo?.items),
  };
}

export default useHomeDestaques;
